module.exports = __webpack_public_path__ + "media/input4.586dd349.wav";